<script setup lang="js">

</script>

<template>
  <div class="my-3 md:my-3 lg:my-5 w-full flex justify-center">
    <div
        class="text-center w-2/3 font-bold text-white text-3xl md:text-3xl lg:text-[1.8rem] py-3 md:py-3 lg:py-5 bg-[#161981]">
      提交
    </div>
  </div>
</template>

<style scoped>

</style>
